module.exports = __webpack_public_path__ + "img/瑞柏美整形.2f402df.png";